import {UI} from "../../../stem-core/src/ui/UIBase";
import {styleRule, styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {PoweredByBlink} from "../panel-elements/PoweredByBlink";
import {isSmallScreen} from "../../UtilsLib";
import {BasePanelPage, BasePanelPageStyle} from "../PanelPage";
import {iFrameState} from "../../services/IFrameState.js";
import {isString} from "../../Utils.ts";
import {iframeToSdkChannel} from "../../../blink-sdk/messaging/IframeToSdkChannel.js";
import {iFrameConnection} from "../../services/IFrameConnection.js";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages.js";


class OAuthConnectStyle extends BasePanelPageStyle {
    @styleRuleInherit
    container = {
        padding: null,
    }

    @styleRuleInherit
    body = {
        flex: 1,
        display: "flex",
        flexDirection: "column"
    }

    @styleRuleInherit
    content = {
        width: 960,
        maxWidth: "90%",
        flex: 1,
        padding: isSmallScreen() ? null : "18px 36px 18px 36px",
    }

    @styleRule
    poweredByBlink = {
        display: isSmallScreen() ? "none" : "",
    }
}

function extractOAuthURL() {
    // We'll extract and validate all the option from there
    const url = new URL(iFrameState.merchantPageUrl);
    const searchParams = new URLSearchParams(url.search);
    const clientId = searchParams.get("client_id");  // Required
    const redirectUri = searchParams.get("redirect_uri");  // Required
    const state = searchParams.get("state"); // Optional

    if (!clientId) {
        throw new Error("Missing clientId from URL arguments");
    }

    if (!redirectUri) {
        throw new Error("Missing redirectUri from URL arguments");
    }

    return {clientId, redirectUri, state};
}

async function GetTokenAndAuthenticate() {
    const oauthParams = extractOAuthURL();
    const response = await apiClient.post("/oauth/authorize", oauthParams);
    const {redirectTo} = response || {};
    if (!redirectTo) {
        throw new Error("Missing redirect response");
    }

    iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL, {url: redirectTo});
}


@registerStyle(OAuthConnectStyle)
export class OAuthConnectPanel extends BasePanelPage {
    status = null;

    async startRequest() {
        try {
            await GetTokenAndAuthenticate();
        } catch (error) {
            console.log("Caught error", error);
            this.error = error;
            this.redraw();
        }
    }

    render() {
        const {styleSheet} = this;

        if (!this.status) {
            this.status = "Redirecting your authentication...";
            this.startRequest().then();
        }

        const formatError = (error) => {
            if (!isString(error)) {
                return error?.message || error?.toString();
            }
            return error;
        }

        return [
            <div className={styleSheet.tabAreaContainer}>
                <h1>{this.error ? "Error: " + formatError(this.error) : this.status}</h1>
            </div>,
        ];
    }
}
